import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';  
import { statusCheck } from '../public';

export const useCardStore = defineStore('card', {
  state: () => ({
    cardStatus: '',
    cardInfo: {},
    cradTransaction: {},
    kycStatus: '',
  }),
  actions: {
    async fetchCardInfo() {
      try{
      const response = await useHttp().get('/api/driver/card/info');
      // 檢查是否為 "No EML CashCard found" 錯誤
      if (response.data && response.data.message && response.data.message.includes('No EML CashCard found')) {
        // 如果是這個錯誤，不顯示錯誤訊息，直接重置狀態並導向 noCard
        this.cardStatus = '';
        this.cardInfo = {};
        return;
      }
      // 檢查 success 為 false 的情況（可能是其他錯誤）
      if (response.data && response.data.success === false) {
        // 如果不是 "No EML CashCard found" 錯誤，使用 statusCheck 顯示錯誤訊息
        statusCheck(response.data);
        // 重置狀態
        this.cardStatus = '';
        this.cardInfo = {};
        return;
      }
      if (statusCheck(response.data)) {
        this.cardStatus = response.data.success;
        this.cardInfo = response.data.response;
        
        
        
      }
      } catch (error) {
        // 檢查錯誤訊息是否包含 "No EML CashCard found"
        const errorMessage = error.response?.data?.message || error.message || '';
        if (errorMessage.includes('No EML CashCard found')) {
          // 如果是這個錯誤，不顯示錯誤訊息，直接重置狀態並導向 noCard
          this.cardStatus = '';
          this.cardInfo = {};
          return;
        }
        // 其他錯誤也重置狀態，靜默處理（不顯示錯誤訊息）
        this.cardStatus = '';
        this.cardInfo = {};
      }
    },
    async applyNewCard(newCardInfo) {
        try{
            const formData = new FormData();
            formData.append('first_name', newCardInfo.first_name);
            formData.append('middle_name', newCardInfo.middle_name ?? '');
            formData.append('last_name', newCardInfo.last_name);
            formData.append('address_line_1', newCardInfo.address_line_1);
            formData.append('address_line_2', newCardInfo.address_line_2);
            formData.append('postcode', newCardInfo.postcode);
            formData.append('suburb', newCardInfo.suburb);
            formData.append('state', newCardInfo.state);
            formData.append('country', newCardInfo.country);
            formData.append('date_of_birth', newCardInfo.date_of_birth);

            const response = await useHttp().post('/api/driver/card/apply', formData); // 添加 formData 參數
            if (statusCheck(response.data)) {
                this.cardStatus = response.data.success;
                return response.data; // 返回響應數據
            }
        } catch (error) {
            console.error('Error applying new card:', error);
            throw error;
        }
    },
    async activateCard(EAID) {
      try{
        const formData = new FormData();
        formData.append('EAID', EAID);
        const response = await useHttp().post('/api/driver/card/activate', formData);
        if (statusCheck(response.data)) {
          this.cardStatus = response.data.success;
          return response.data; // 返回響應數據
        }
      } catch (error) {
        console.error('Error activating card:', error);
        throw error;
      }
    },
    async lockCard(action) {
      try{
        const formData = new FormData();
        if (action === 'lock') {
          formData.append('action', 'lock');
        } else if (action === 'unlock') {
          formData.append('action', 'unlock');
        } else {
          formData.append('action', 'closed');
        }
        formData.append('card_id', this.cardInfo.id);
        const response = await useHttp().post('/api/driver/card/lock', formData);
        if (statusCheck(response.data)) {
          this.cardStatus = response.data.success;
        }
      } catch (error) {
        console.error('Error locking card:', error);
        throw error;
      }
    },
    async lostCard(){
        try{
            const response = await useHttp().post('/api/driver/card/lost');
            if (statusCheck(response.data)) {
                this.cardStatus = response.data.success;
            }
        }catch(error){
            console.error('Error lost card:', error);
            throw error;
        }
    },
    async deactivateEmail() {
      try {
        // 發送停用卡片通知信
        const response = await useHttp().get('/api/driver/card/deactivate-email');
        if (statusCheck(response.data)) {
          return response.data; // 成功回傳訊息
        }
        return null;
      } catch (error) {
        console.error('Error calling deactivate-email:', error);
        throw error;
      }
    },
    async getCradTransaction(transaction) {
      try{
        
        
        // 將參數作為查詢參數傳遞給 GET 請求
        const response = await useHttp().get('/api/driver/card/transactions', {
          params: transaction
        });
        
       
        
        if (statusCheck(response.data)) {
          // 根據 API 響應結構，交易資料在 response.data.transactions
          this.cradTransaction = response.data.transactions || response.data.data;
          
          return response.data; // 回傳完整資料（含 meta）
        } else {
         
          return null;
        }
      } catch (error) {
        
        throw error;
      }
    },
    async getKYCStatus() {
      try{
        const response = await useHttp().get('/api/driver/card/kyc');
        if (statusCheck(response.data)) {
          this.kycStatus = response.data.data;
        }
      } catch (error) {
        console.error('Error KYC status:', error);
        throw error;
      }
    },
    async getCardPlastic(){
      try{
        const response = await useHttp().post('/api/driver/card/plastic');
        if(statusCheck(response.data)){
          return response.data;
        }
        else{
          throw new Error('Failed to get card plastic');
        }
      } catch (error){
        console.error('Error getting card plastic:', error);
        throw error;
      }
    }
  }
});